import axios from "axios";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();

const BASE_URL = publicRuntimeConfig.API_URL;
class RestConnector {
  constructor() {
    this.axios = axios.create({ baseURL: BASE_URL });
  }

  set accessToken(token) {
    if (token) {
      this.axios.defaults.headers.Authorization = token;
      localStorage.setItem("token", token);
    } else {
      delete this.axios.defaults.headers.Authorization;
      localStorage.removeItem("token");
    }
  }

  post(...args) {
    return this.axios.post(...args);
  }

  get(...args) {
    return this.axios.get(...args);
  }

  patch(...args) {
    return this.axios.patch(...args);
  }

  put(...args) {
    return this.axios.put(...args);
  }

  delete(...args) {
    return this.axios.delete(...args);
  }
}

const globalInstance = new RestConnector();

export default globalInstance;



// WEBPACK FOOTER //
// client/lib/RestConnector.js